import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "options" }

import store from "@/store";
import PassCard from "@/components/RegistrationPage/Card/MobileVersion/PassCard.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'SubscriptionsHolder',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.passes, (pass, i) => {
      return (_openBlock(), _createBlock(PassCard, {
        key: i,
        pass: pass
      }, null, 8, ["pass"]))
    }), 128))
  ]))
}
}

})